import { render } from "./AdminPermissions.vue?vue&type=template&id=560e2590"
import script from "./AdminPermissions.vue?vue&type=script&lang=js"
export * from "./AdminPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__